import React, { useEffect, useState } from "react";
import { Box, Typography, TextField, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { finishMagicLinkLogin } from "../lib/emailLinkAuth";

const PROJECT = process.env.REACT_APP_FIREBASE_PROJECT_ID;
const REGION = "europe-west3";
const CF_BASE =
  process.env.REACT_APP_CF_BASE || `https://${REGION}-${PROJECT}.cloudfunctions.net`;

export default function FinishEmailLogin() {
  const nav = useNavigate();

  const [msg, setMsg] = useState("Finishing email login...");
  const [needEmail, setNeedEmail] = useState(false);
  const [email, setEmail] = useState("");

  const complete = async (emailOverride) => {
    try {
      const res = await finishMagicLinkLogin(emailOverride);

      if (!res?.ok) {
        if (res?.reason === "missing_email") {
          setNeedEmail(true);
          setMsg("Enter the email you used to request the link:");
          return;
        }
        setNeedEmail(false);
        setMsg("This link is not valid here.");
        return;
      }

      const user = res.user;
      if (!user) throw new Error("No Firebase user in email-link result");

      setNeedEmail(false);
      setMsg("Syncing profile...");

      // ✅ берём токен у user, НЕ у auth.currentUser
let idToken = "";
try {
  idToken = await user.getIdToken(true);
  console.log("[FinishEmailLogin] got idToken len:", idToken?.length);
} catch (e) {
  console.error("[FinishEmailLogin] getIdToken FAILED:", e);
  throw e;
}

const r = await fetch(`${CF_BASE}/onUserCreated`, {
  method: "POST",
  headers: { Authorization: `Bearer ${idToken}` }
});

const text = await r.text().catch(() => "");
console.log("[FinishEmailLogin] onUserCreated status:", r.status, "body:", text);

if (!r.ok) {
  throw new Error(text || `onUserCreated failed (${r.status})`);
}

// ✅ форсим рефреш, чтобы customClaims подтянулись сразу
await user.getIdToken(true);

      // ✅ редирект
      nav("/market", { replace: true }); // или "/" если нужно
    } catch (e) {
      console.error(e);
      setMsg(e?.message || "Email login failed");
    }
  };

  useEffect(() => {
    complete(); // пробуем без emailOverride
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box sx={{ minHeight: "100vh", display: "grid", placeItems: "center", bgcolor: "#070b12" }}>
      <Box
        sx={{
          width: "min(520px, 92vw)",
          p: 3,
          borderRadius: 3,
          border: "1px solid rgba(255,255,255,.10)",
          bgcolor: "rgba(18,22,28,.72)",
          color: "#e5e7eb"
        }}
      >
        <Typography fontWeight={900} mb={1}>PromosPay</Typography>
        <Typography sx={{ opacity: 0.8, mb: needEmail ? 2 : 0 }}>{msg}</Typography>

        {needEmail && (
          <>
            <TextField
              fullWidth
              size="small"
              placeholder="Email address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              InputProps={{
                sx: {
                  borderRadius: 2,
                  bgcolor: "rgba(255,255,255,.06)",
                  color: "#e5e7eb",
                  border: "1px solid rgba(255,255,255,.10)"
                }
              }}
            />
            <Button
              sx={{ mt: 2, borderRadius: 2, fontWeight: 900, textTransform: "none" }}
              variant="contained"
              onClick={() => complete(email)}
              disabled={!email.includes("@")}
            >
              Continue
            </Button>
          </>
        )}
      </Box>
    </Box>
  );
}
